import { createFileRoute } from "@tanstack/react-router";
import { optionalLiteralParam, parseableSearchSchema } from "@crm/effect/schema/search";
import { Schema } from "effect";

const npsSearchSchema = parseableSearchSchema(
  Schema.Struct({
    category: optionalLiteralParam("all", "promoter", "passive", "detractor"),
  }),
);

export const Route = createFileRoute("/_protected/dashboard/metrics/_details/nps/")({
  validateSearch: npsSearchSchema
});
